import { AuthState } from "./types";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { SIGNUP_PROVIDER_STORAGE_KEY } from "../const.ts";

const urlParams = new URLSearchParams(window.location.search);
const urlToken = urlParams.get("token") || "";
const urlSignUpToken = urlParams.get("signUpToken") || "";

const token = urlToken || localStorage["token"] || "";
const signUpToken = urlSignUpToken || localStorage["signUpToken"] || "";

if (urlToken || urlSignUpToken) {
  const currentPath = window.location.pathname;
  if (currentPath != "/integration/e-conomic/connect") {
    // Remove the token from the URL and navigate to returnTo path if set
    const returnTo = localStorage.getItem("returnTo") || "/";
    localStorage.removeItem("returnTo");
    window.history.replaceState({}, document.title, returnTo);
    localStorage["token"] = token;
    localStorage["signUpToken"] = signUpToken;
  }
}

const initialState: AuthState = {
  isLoggedIn: false,
  loginToken: "",
  anonymousSession: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState: initialState,
  reducers: {
    login(state: AuthState, action: PayloadAction<string>) {
      state.isLoggedIn = true;
      state.loginToken = action.payload;
      state.anonymousSession = null;
      localStorage["signUpToken"] = "";
      localStorage.removeItem(SIGNUP_PROVIDER_STORAGE_KEY);
    },
    logout(state: AuthState) {
      state.isLoggedIn = false;
      state.loginToken = "";
      localStorage["token"] = "";
      localStorage["signUpToken"] = "";
      localStorage.removeItem(SIGNUP_PROVIDER_STORAGE_KEY);
      localStorage.removeItem("welcome_conversation_identifier");
      localStorage.removeItem("partnerToken");
      state.anonymousSession = null;
    },
    loginAsAnonymousUser(state: AuthState) {
      state.anonymousSession = {
        signUpState: null,
      };
    },
    updateSignUpState(state: AuthState, action: PayloadAction<any>) {
      state.anonymousSession = {
        ...state.anonymousSession,
        signUpState: {
          ...state.anonymousSession?.signUpState,
          ...action.payload,
        },
      };
    },
  },
});

export default authSlice.reducer;
export const { login, logout, loginAsAnonymousUser, updateSignUpState } =
  authSlice.actions;
